import { DashboardWrapper } from "@/components/dashboard/DashboardWrapper";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Dashboard() {
  usePageMeta("Dashboard — Shattara AI", "", { noIndex: true });
  return <DashboardWrapper />;
}
